
/**
 * 首页容器
 */
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, State } from "vuex-class";
import { TabDto } from "@/api/goodsModule";
import { getMicroStoreInfo } from "@/api/store";
import more from "./tabbar-more/index.vue";
import OpenStorePop from "@/components/openCCXStorePopup/OpenStorePop.vue";
import SuccessOpenStorePop from "@/components/openCCXStorePopup/SuccessOpenStorePop.vue";
import GlassFilter from "@/components/GlassFilter/index.vue";
Component.registerHooks(["beforeRouteUpdate"]);

@Component({
  name: "ShopHomeLayout",
  components: {
    more,
    OpenStorePop,
    SuccessOpenStorePop,
    GlassFilter,
  },
})
export default class ShopHomeLayout extends Vue {
  @Getter includedComponents: string[];
  @Getter info: any; // 用户信息
  @Getter routerAliveStatus;
  @Getter tabModules!: Array<TabDto>;
  @Getter companyId!: string;
  @Getter topSafetyHeight!: number;
  @Getter isMultiStore!: boolean;
  @Getter aiSourceUrl!: string;
  include = [];

  active = "/mall";
  tabbarZIndex = 1; // 当more组件显示为9999，关闭为1

  // 长按相关
  longPressTimer: any = null;
  isLongPress = false;
  touchStartTime = 0;
  targetUrl = "";
  showConfigDialog = false;

  $refs: {
    moreRef: more;
    openStorePopRef: OpenStorePop;
    successOpenStorePopRef: SuccessOpenStorePop;
  };

  @Watch("$route")
  handleRouteChange(to: any, from: any) {
    if (this.isShowBottomTab) {
      console.log(
        "🚀 ~ ShopHomeLayout ~ handleRouteChange ~ this.isShowBottomTab:",
        this.isShowBottomTab,
      );
      const paths = this.handledTabs.map((i) => i.route);
      if (
        [
          ...paths,
          "/shopMallOrder",
          "/workbench",
          "/shopManage",
          "/statement",
          "/my",
        ].includes(to.path)
      ) {
        this.active = to.path;
      } else {
        this.active = "/more";
      }
    }
  }

  get isShow() {
    return this.info.currentVersionCode !== "system";
    // return true
  }
  // get isShowTopBar() {
  //   const paths = this.handledTabs.map((i) => i.route);
  //   return ["/shopManage", "/statement", ].includes(this.$route.path);
  // }
  get isShowBottomTab() {
    const paths = this.handledTabs.map((i) => i.route);
    // return [...paths, '/shopMallOrder'].includes(this.$route.path);
    // return ['/mall','/mallCategory', '/buyMallCar', '/goods', '/shelf', '/salesSlip', '/salespromotion', '/salesstatistics', '/shopMallOrder'].includes(this.$route.path);
    return (
      ["/workbench", "/shopManage", "/statement", "/my"].includes(
        this.$route.path,
      ) &&
      (Boolean(this.companyId) || this.isMultiStore)
    );
  }

  get handledTabs() {
    return this.tabModules.filter((t) => t.isShow);
  }

  async beforeRouteUpdate(to, from, next) {
    // 当进入我的货架、销售单、促销活动、销售统计页面，需判断用户是否开通常常鲜店铺
    const paths = [
      "/shelf",
      "/salesSlip",
      "/salespromotion",
      "/salesstatistics",
    ];
    if (paths.includes(to.path)) {
      // 是否开通店铺
      const { data } = await getMicroStoreInfo({ storeId: this.companyId });
      // 0未开通1开通
      if (data.openOnlineStore === 0) {
        // 弹去开通弹窗
        this.$refs.openStorePopRef.showPopup();
        this.active = from.path;
        next(false);
      } else {
        next();
      }
    } else {
      next();
    }
  }

  onChange(active) {
    // console.log('onChange', active);
    // this.active = active;
  }

  created() {
    this.include = this.includedComponents;
    // console.log('app-====',this.routerAliveStatus);
    this.active = this.$route.path;
    this.$eventBus.$on("isSuccessOpenStore", () => {
      this.$refs.successOpenStorePopRef.showPopup();
    });
  }

  destroyed() {
    this.$eventBus.$off("isSuccessOpenStore");
  }

  toMore() {
    (this.$refs.moreRef as any).show();
  }

  onMoreIsShow(bool) {
    // 当more组件显示为9999，关闭为1
    setTimeout(
      () => {
        this.tabbarZIndex = bool ? 9999 : 1;
      },
      bool ? 0 : 300,
    );
  }

  // 触摸开始
  onTouchStart(e: TouchEvent) {
    this.isLongPress = false;
    this.touchStartTime = Date.now();

    // 设置长按定时器，800ms后触发长按
    this.longPressTimer = setTimeout(() => {
      this.isLongPress = true;
      this.showConfigDialog = true;
      this.targetUrl = this.aiSourceUrl;
    }, 800);
  }

  setAiSourceUrl(val: string) {
    this.$store.commit("SET_AI_SOURCE_URL", val);
  }

  // 弹窗关闭前处理
  onBeforeClose(action: string, done: (allow?: boolean) => void) {
    if (action === "confirm") {
      if (!this.targetUrl) {
        this.$toast.fail("请输入访问地址");
        done(false); // 阻止弹窗关闭
      } else {
        this.setAiSourceUrl(this.targetUrl);
        this.$toast.success("配置已保存");
        done(); // 允许弹窗关闭
      }
    } else {
      // 取消按钮
      done(); // 允许弹窗关闭
    }
  }

  // 触摸结束
  onTouchEnd(e: TouchEvent) {
    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer);
      this.longPressTimer = null;
    }

    if (!this.isLongPress) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
  }

  // 触摸移动
  onTouchMove(e: TouchEvent) {
    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer);
      this.longPressTimer = null;
    }
  }

  toAi() {
    if (!this.aiSourceUrl) {
      this.$toast.fail("请配置访问地址");
      return;
    }
    this.$router.push({
      path: "/ai",
    });
  }
}
